
// npm
import React from 'react'
import PropTypes from 'prop-types'

// react
import {Popup} from 'components/layout/popup'
import {CancelButton} from './buttons/cancel'
import {ConfirmButton} from './buttons/confirm'
import {withMessages} from 'components/hocs/messages'

// constants
import {MESSAGE_IDS} from 'constants/message-ids'


const practiceFinishConfirmTitle1 = MESSAGE_IDS.EXAM.FINISH_CONFIRM_PRACTICE_TITLE_1;
const practiceFinishConfirm1 = MESSAGE_IDS.EXAM.FINISH_CONFIRM_PRACTICE_INFO_1;


let PracticeFinishConfirmPopup = ({onClose, onConfirm, messages}) =>
{
	const props = {
		title: messages[practiceFinishConfirmTitle1],
		content: {text: messages[practiceFinishConfirm1]},
		buttons: [
			<ConfirmButton onClick={onConfirm}/>,
			<CancelButton onClick={onClose}/>
		],
		onClose
	}

	return <Popup {...props}/>;
}

PracticeFinishConfirmPopup.propTypes = {
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	messages: PropTypes.shape({
		[practiceFinishConfirmTitle1]: PropTypes.string.isRequired,
		[practiceFinishConfirm1]: PropTypes.string.isRequired
	}).isRequired
}


PracticeFinishConfirmPopup = withMessages(PracticeFinishConfirmPopup);


export {PracticeFinishConfirmPopup}